import { defineComponent as _defineComponent } from 'vue'
import Card from './CardWidgetCard.vue';
import { CardWidgetResource } from 'JS/dxp/types/widgets/card-widget';
import { computed } from 'vue';
import { cssVarsToStyleString } from 'JS/dxp/utilities/css-vars';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardWidget',
  props: {
    widget: null
  },
  setup(__props: any) {

const props = __props as {
	widget: CardWidgetResource
}



const mobileGridAreas = computed(() => props.widget.data.reduce((string, _, i) => string += `"c${i}"`, ""));

const tabletGridAreas = computed(() => {
	const { length } = props.widget.data;

	if (length == 2) {
		return  '"c0 c1"';
	} else if (length == 3) {
		return `"c0 c1"
                "c2 c2"`;
	} else if (length == 4) {
		return  `"c0 c1"
				 "c2 c3"`;
	} else if (length == 5) {
		return `"c0 c1"
				"c2 c3"
				"c4 c4"`;
	} else {
		return `"c0 c1"
				"c2 c3"
				"c4 c5"`;
	}
});

const desktopGridAreas = computed(() => {
	const { length } = props.widget.data;

	if (length == 2) {
		return  '"c0 c1"';
	} else if (length == 3) {
		return '"c0 c1 c2"';
	} else if (length == 4) {
		return  `"c0 c1"
				 "c2 c3"`;
	} else if (length == 5) {
		return `"c0 c0 c1 c1 c2 c2"
                "c3 c3 c3 c4 c4 c4"`;
	} else {
		return `"c0 c1 c2"
				"c3 c4 c5"`;
	}
});


return { __sfc: true,props, mobileGridAreas, tabletGridAreas, desktopGridAreas, Card, cssVarsToStyleString }
}

})